import type { RootState } from 'src/redux/store';

import { useAppSelector } from 'src/hook/hooks';

/**
 * Outbound voice (click-to-call, dialer, chat header call) is allowed when tenant-wide VOICE
 * is enabled in auth channel flags (same signal as dashboard voice widgets).
 */
export function useVoiceCallAllowed(): boolean {
  const { channelFeatureFlags, channelFeatureFlagsInitialized } = useAppSelector(
    (state: RootState) => state.auth
  );
  return Boolean(channelFeatureFlagsInitialized && channelFeatureFlags.VOICE === true);
}
